import { makeDataObjGenerator } from 'mocks/helpers'

export const defaultData = {
  id: '00000000-0000-0000-0000-000000000000',
  name: 'Fred’s School friends',
  playerIds: [
    '605b814f007546722aa6697e',
    '605b807c007546722aa647b9',
    '604a0208dc035b1d06b7dc7b',
    '605b7fdc007546722aa62982',
    '605b814f007546722aa6698d',
    '605b807d007546722aa647f9',
  ],
}

export const createWatchlists = makeDataObjGenerator(defaultData)
